export default {
    getDataPlans: state => state.dataPlans,
    getTVSubscriptions: state => state.TVSubscriptions
}